import { t } from "i18next";
import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { debugLogActions } from "../helpers/debugHelper";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";

export const startGetModulesByUserIdSelected = (user) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE_MODULE}`,
      `get-modules-by-userid/${user.id}`
    );
    const body = await resp.json();

    if (body.ok) {

       debugLogActions(':: userRoleModuleActions, startGetModulesByUserIdSelected', { 'body': body });
      
      dispatch(getModulesByUserIdSelected(body.listUserRoleModules));

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const getModulesByUserIdSelected = (listUserRoleModules) => ({
  type: types.USERROLEMODULE_GET_LIST_MODULES,
  payload: listUserRoleModules,
});

export const startRegisterUserRoleModulesList = (userModules, idUserRole) => {
  return async (dispatch) => {
    const userModulesObjectSend = {
      userModulesObject: { userModules, idUserRole },
    };

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_USER_ROLE_MODULE}`,
      "add-list",
      userModulesObjectSend,
      "POST"
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(registerUserRoleModulesList(userModules));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const registerUserRoleModulesList = (userRole) => ({
  type: types.USERROLEMODULE_START_REGISTER_LIST,
  payload: userRole,
});